// 환경 변수 가져오기
const DEV = process.env.REACT_APP_DEV;
const DEPLOY = process.env.REACT_APP_DEPLOY;

// // 현재 환경에 따른 base URL 결정
const BASE = DEPLOY; // 또는 환경에 따라 DEPLOY로
// const BASE = DEV; // 또는 환경에 따라 DEV

// 환경에 따른 컬렉션 이름 결정
export const getCollectionName = () => {
  // BASE가 DEV인지 DEPLOY인지에 따라 컬렉션 이름 결정
  // 실제 환경 변수 값을 비교하여 결정
  if (BASE === DEV) {
    return "dev";
  } else {
    return "deploy";
  }
};

// 특별한 권한을 가진 유저 ID들 (날짜 제한 없음)
export const getSpecialUserIds = () => {
  // 환경변수에서 가져오거나 기본값 사용
  const specialUserIds = process.env.REACT_APP_SPECIAL_USER_IDS || "1";
  return specialUserIds.split(",").map((id) => parseInt(id.trim()));
};

// 특정 유저가 특별한 권한을 가진 유저인지 확인
export const isSpecialUser = (userId) => {
  if (!userId) return false;
  const specialIds = getSpecialUserIds();
  return specialIds.includes(parseInt(userId));
};

// 현재 환경 정보 반환
export const getEnvironmentInfo = () => {
  return {
    base: BASE,
    collection: getCollectionName(),
    isDev: BASE === DEV,
    isDeploy: BASE === DEPLOY,
  };
};
